import classNames from 'classnames'
import { h, JSX } from 'preact'

import { Numberfield, NumberfieldProps } from '../forms/numberfield/numberfield'
import { Select, SelectProps } from '../forms/select/select'
import { RemoveIcon } from '../icon/icon'

export interface TicketsTableProps {
    modifier?: string
    class?: string
    isInvalid?: boolean
    error?: string
    rows?: RowProps[]
    total?: {
        title: string
        sum: string
    }
}

export interface RowProps {
    reactKey: string
    isTicket?: boolean
    isProduct?: boolean
    onRemove?: () => unknown
    title: string
    subtitle?: string
    price?: string
    select?: SelectProps
    numberField?: NumberfieldProps
    variants?: ProductVariantProps[]
    noteLines?: string[]
}

export interface ProductVariantProps {
    id: number
    name: string
    quantity: NumberfieldProps
    price: string
}

export const TicketsTable = (props: TicketsTableProps): JSX.Element => {
    const className = classNames('tickets-table', props.modifier, props.class, {
        'is-invalid': props.isInvalid,
    })

    // TODO section headings on mobile

    return (
        <div class={className}>
            {props.error && <div class="tickets-table__error">{props.error}</div>}
            <ul class="tickets-table__rows">
                {props.rows?.map((row) => <Row key={row.reactKey} {...row} />)}
            </ul>
            {props.total && (
                <div class="tickets-table__total">
                    <div class="tickets-table__total-title">{props.total.title}</div>
                    <div class="tickets-table__total-sum">{props.total.sum}</div>
                </div>
            )}
        </div>
    )
}

const Row = (props: RowProps): JSX.Element => (
    <li
        class={classNames(
            'tickets-table__row',
            props.isTicket && 'tickets-table__row--ticket',
            props.isProduct && 'tickets-table__row--product',
        )}
    >
        {props.onRemove && (
            <button type="button" class="tickets-table__remove" onClick={props.onRemove}>
                <RemoveIcon />
            </button>
        )}
        <h4
            class={classNames(
                'tickets-table__row-title',
                props.isProduct && 'tickets-table__row-title--product',
            )}
        >
            {props.title}
            {props.subtitle && <span class="tickets-table__row-subtitle">{props.subtitle}</span>}
        </h4>
        {props.price && <div class="tickets-table__row-price">{props.price}</div>}
        {props.select && (
            <Select
                modifier="select--hide-label"
                class="tickets-table__row-select"
                {...props.select}
            />
        )}
        {props.numberField && (
            <Numberfield
                modifier="numberfield--hide-label tickets-table__row-numberfield"
                {...props.numberField}
            />
        )}
        {props.variants && (
            <div class="tickets-table__row-variants">
                {props.variants.map((variant) => (
                    <div key={variant.id} class="tickets-table__row-variant">
                        <div class="tickets-table__row-variant-name">{variant.name}</div>
                        <Numberfield modifier="numberfield--hide-label" {...variant.quantity} />
                        <div class="tickets-table__row-price">{variant.price}</div>
                    </div>
                ))}
            </div>
        )}
        {props.noteLines && (
            <span class="tickets-table__row-note">
                {props.noteLines.map((line, index) => (
                    <div key={index}>{line}</div>
                ))}
            </span>
        )}
    </li>
)
